// extracted by mini-css-extract-plugin
export default {"content":"Notion_content__vqegn"};